


export function Portraits () {
    return (
<main className="portraits-page">
    <header className="portraits-intro">
        <p className="portraits-kicker">Collection from my travels</p>
        <h1>Portraits</h1>
    </header>
    <div className="row  contact-sheet m-1">
        <img src="../../../images/projects/portraits/dan.png" className="col-4 p-0 m-0"   width="100%" loading="lazy" />
        <img src="../../../images/projects/portraits/choked-up.png" className="col-4 p-0 m-0"   width="100%" loading="lazy" />
        <img src="../../../images/projects/portraits/john.png" className="col-4 p-0 m-0"   width="100%" loading="lazy" />
        <img src="../../../images/projects/portraits/train-portrait.png" className="col-4 p-0 m-0"   width="100%" loading="lazy" />
        <img src="../../../images/projects/portraits/slip-way.png" className="col-4 p-0 m-0"   width="100%" loading="lazy" />
        <img src="../../../images/projects/portraits/lewis.png" className="col-4 p-0 m-0"   width="100%" loading="lazy" />
        <img src="../../../images/projects/portraits/lady-in-blue.png" className="col-4 p-0 m-0"   width="100%" loading="lazy" />
        <img src="../../../images/projects/portraits/horse-beach.png" className="col-4 p-0 m-0"   width="100%" loading="lazy" />
        <img src="../../../images/projects/portraits/clown.png" className="col-4 p-0 m-0"   width="100%" loading="lazy" />
        <img src="../../../images/projects/portraits/jade-wales.png" className="col-4 p-0 m-0"   width="100%" loading="lazy" />
        <img src="../../../images/projects/portraits/burnie.png" className="col-4 p-0 m-0"   width="100%" loading="lazy" />
        <img src="../../../images/projects/portraits/milly.png" className="col-4 p-0 m-0"   width="100%" loading="lazy" />
        <img src="../../../images/projects/portraits/man-on-bridge.png" className="col-4 p-0 m-0"   width="100%" loading="lazy" />
        <img src="../../../images/projects/portraits/cafe-lady.png" className="col-4 p-0 m-0"   width="100%" loading="lazy" />
        <img src="../../../images/projects/portraits/andy-april.png" className="col-4 p-0 m-0"   width="100%" loading="lazy" />
        <img src="../../../images/projects/portraits/rob.png" className="col-4 p-0 m-0"   width="100%" loading="lazy" />
        <img src="../../../images/projects/portraits/kevin.png" className="col-4 p-0 m-0"   width="100%" loading="lazy" />
        <img src="../../../images/projects/portraits/pick-a-card.png" className="col-4 p-0 m-0"   width="100%" loading="lazy" />
        <img src="../../../images/projects/portraits/liam.png" className="col-4 p-0 m-0"   width="100%" loading="lazy" />
    </div> 
</main>
    )}
